<template>
  <div>
    <div class="l-container">
      <router-view :paymentdetails2="paymentdetails2"></router-view>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    paymentdetails2 () {
      return this.$store.getters.paymentdetails2
    }
  },
  data () {
    return {
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getPaymentdetails2(to.params.id)
    })
  },
  methods: {
    getPaymentdetails2 (id) {
      this.$store.dispatch('getPaymentdetails2', id)
    }
  },
  mounted () {
  },
  route: {
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// Paymentdetails2.vue?449b1dd0